import { render, staticRenderFns } from "./ResourceCreate.vue?vue&type=template&id=1b0e3d5f&scoped=true&"
import script from "./ResourceCreate.vue?vue&type=script&lang=ts&"
export * from "./ResourceCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e3d5f",
  null
  
)

export default component.exports